export function SkeletonStats({ cols = 4 }) {
    return (
        <div className="skeleton-stats" style={{ gridTemplateColumns: `repeat(${cols},1fr)` }}>
            {Array.from({ length: cols }).map((_, i) => (
                <div key={i} className="sk-stat">
                    <div className="skeleton skeleton-h" style={{ width: '40%', marginBottom: 10 }} />
                    <div className="skeleton skeleton-h" style={{ height: 24, width: '70%', marginBottom: 6 }} />
                    <div className="skeleton skeleton-p" style={{ width: '50%' }} />
                </div>
            ))}
        </div>
    )
}

export function SkeletonCard({ lines = 3 }) {
    return (
        <div className="skeleton-card">
            <div className="skeleton skeleton-h" style={{ width: '60%', marginBottom: 12 }} />
            {Array.from({ length: lines }).map((_, i) => (
                <div key={i} className="skeleton skeleton-p" style={{ width: i === lines - 1 ? '40%' : '90%' }} />
            ))}
        </div>
    )
}

export function SkeletonList({ count = 4 }) {
    return (
        <>
            {Array.from({ length: count }).map((_, i) => (
                <SkeletonCard key={i} lines={2} />
            ))}
        </>
    )
}
